import React, { PropsWithChildren, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList } from '@/components/ui/tabs'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'

export enum TradingAccountTab {
  Details = 'details',
  Statistics = 'statistics',
  Transactions = 'transactions',
  Positions = 'open-positions',
  Orders = 'orders',
  PlatformTransactions = 'platform-transactions',
}

export interface TradingAccountNavigationProps {
  data?: {
    id: string
    name: string
  }
  hideTabs?: boolean
  isEdit: boolean
  tab: TradingAccountTab
}

export const TradingAccountNavigation: React.FC<
  PropsWithChildren<TradingAccountNavigationProps>
> = (props) => {
  const navigate = useNavigate()
  const { data, isEdit } = props
  const [confirmationModal, setConfirmationModal] = useState<boolean>(props.isEdit)
  const [keyToChange, setKeyToChange] = useState<string>(TradingAccountTab.Details)

  const handleTabClick = async (key: string) => {
    setKeyToChange(key)
    if (isEdit) setConfirmationModal(true)
    else navigate(`../${key}`, { relative: 'path' })
  }

  const handleTabChange = (reason: boolean) => {
    if (reason) {
      navigate(`../${keyToChange}`, { relative: 'path' })
    }
    setConfirmationModal(false)
  }

  return (
    <div>
      <ConfirmationModal
        contentText='The page is asking you to confirm that you want to leave - data you have enter may not be saved.'
        yesButtonText='Leave Page'
        cancelButtonText='Stay on page'
        onYes={() => handleTabChange(true)}
        onCancel={() => handleTabChange(false)}
        visible={confirmationModal}
      />
      <NavigationHeader>{data && <span>{data.name}</span>}</NavigationHeader>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <div className='w-full mb-1.25'>
          <TabsList>{props.children}</TabsList>
        </div>
      </Tabs>
    </div>
  )
}
